export enum ConfigManagerProperties {
  buildVersion = 'buildVersion',
  production = 'production',
  apiUrl = 'apiUrl',
  appName = 'appName',
  region = 'region',
  enableProReprocess = 'enableProReprocess',
}
